import { Button, Card, Form, Input, message, Select, Space } from "antd";
import Validators from "Common/Validators";
import React, { useEffect, useState } from "react";
import PhoneInput, {
  isValidPhoneNumber,
  formatPhoneNumber,
  formatPhoneNumberIntl,
} from "react-phone-number-input";
import api from "utils/api";
const NewClinician = (props) => {
  const [value, setValue] = useState();
  const [form] = Form.useForm();
  const [buttonLoader, setButtonLoader] = useState(false);
  const [languageOptions, setLanguageOptions] = useState([]);
  const [specialityOptions, setSpecialityOptions] = useState([]);
  const [initialValues, setInitialValues] = useState({});

  function fetchOptions(search) {
    const query = new URLSearchParams({ search }).toString();
    api
      .language_speciality_list(`${query}`)
      .then((response) => {
        const fetchedOptions = response.data?.data?.results.map((item) => ({
          label: item.field_value,
          value: item.id,
        }));
        if (search === "language") {
          setLanguageOptions(fetchedOptions);
        } else if (search === "speciality") {
          setSpecialityOptions(fetchedOptions);
        }
      })
      .catch((error) => {
        console.error(`Failed to fetch ${search} options:`, error);
      });
  }
  // useEffect(()=>{
  //   fetchOptions("speciality");
  //   fetchOptions("language");
  // },[])
  const handleSubmit = (values) => {
    const doctor_id = props?.doctor_id || "";
    const formattedMobileNumber = formatPhoneNumberIntl(values.mobile_number);
    const mobile_number =
      formattedMobileNumber?.split(" ").slice(1).join("") || "";
    const country_code = formattedMobileNumber?.split(" ")[0] || "";

    let payload = {
      doctor_id,
      mobile_number,
      country_code,
      speciality: Array.isArray(values.speciality)
        ? values.speciality
        : [values.speciality],
      language: Array.isArray(values.language)
        ? values.language
        : [values.language],
      ...values,
    };
    setButtonLoader(true);

    if (props?.editData) {
      const updatedFields = Object.keys(payload).reduce((acc, key) => {
        if (key === "mobile_number" || key === "country_code") {
          const initialMobileNumber = formatPhoneNumberIntl(
            initialValues.mobile_number
          );
          const initialMobile =
            initialMobileNumber?.split(" ").slice(1).join("") || "";

          if (mobile_number !== initialMobile) {
            acc["mobile_number"] = mobile_number;
          } else if (key === "country_code") {
            const initialCountryCode =
              formatPhoneNumberIntl(initialValues.mobile_number)?.split(
                " "
              )[0] || "";
            if (country_code !== initialCountryCode) {
              acc["country_code"] = country_code;
            }
          } else {
            acc["mobile_number"] = "";
            acc["country_code"] = "";
          }
        } else if (key === "speciality") {
          const currentSpeciality = Array.isArray(values.speciality)
            ? values.speciality
            : [values.speciality];
          const initialSpeciality = Array.isArray(initialValues.speciality)
            ? initialValues.speciality
            : [initialValues.speciality];
          if (
            JSON.stringify(currentSpeciality) !==
            JSON.stringify(initialSpeciality)
          ) {
            acc[key] = currentSpeciality;
          } else {
            acc[key] = [];
          }
        } else if (
          JSON.stringify(payload[key]) !== JSON.stringify(initialValues[key])
        ) {
          acc[key] = payload[key];
        } else {
          acc[key] = "";
        }
        return acc;
      }, {});
      if (Object.keys(updatedFields).length > 0) {
        api
          .update_doctor_details(updatedFields)
          .then((response) => {
            if (response.data?.status === 200) {
              message.success("Successfully updated");
              props.submitButtonAction();
            } else {
              message.error(response.data?.message);
            }
          })
          .catch((err) => {
            message.error("Something went wrong");
          })
          .finally(() => {
            setButtonLoader(false);
          });
      } else {
        message.info("No changes detected");
        setButtonLoader(false);
      }
    } else {
      api
        .doctor_registration({
          ...payload,
          mobile_number,
          country_code,
          speciality: Array.isArray(values.speciality)
            ? values.speciality
            : [values.speciality],
          language: Array.isArray(values.language)
            ? values.language
            : [values.language],
        })
        .then((response) => {
          if (response.data?.status === 200) {
            message.success("Successfully registered");
            props.submitButtonAction();
          } else {
            message.error(response.data?.message);
          }
        })
        .catch((err) => {
          message.error("Something went wrong");
        })
        .finally(() => {
          setButtonLoader(false);
        });
    }
  };

  const handleFieldChange = (changedValues, allValues) => {
    //   const { speciality } = changedValues;
    //   if (speciality !== undefined && props.editData) {
    //     if (speciality !== initialValues.speciality) {
    //       form.setFields([
    //         { name: "specialization", errors: ["Specialization must be changed"] },
    //         { name: "designation", errors: ["Designation must be changed"] },
    //         { name: "display_designation", errors: ["Display_designation must be changed"] },
    //       ]);
    //     } else {
    //       form.setFields([
    //         { name: "specialization", errors: [] },
    //         { name: "designation", errors: [] },
    //         { name: "display_designation", errors: [] },
    //       ]);
    //     }
    //   }

    props.formAction(true);
  };
  // const handleFieldChange = () => {
  //   const { formAction } = props;
  //   formAction(true);
  // };
  function setFieldsValue() {
    if (props?.editData) {
      const {
        first_name,
        last_name,
        email,
        country_code,
        mobile_number,
        qualification,
        specialization,
        salutation,
        display_name,
        designation,
        display_designation,
        registration_number,
        speciality,
        language,
      } = props.editData;

      const fullMobileNumber = `${country_code}${mobile_number}`;

      const selectedData = {
        first_name,
        last_name,
        email,
        qualification,
        specialization,
        salutation,
        display_name,
        designation,
        display_designation,
        registration_number,
        speciality,
        language,
        mobile_number: fullMobileNumber,
      };
      form.setFieldsValue(selectedData);
      setInitialValues(selectedData);
    }
  }
  useEffect(() => {
    if (props?.editData) {
      setFieldsValue();
    }
  }, [props?.editData, form]);
  return (
    <div>
      <Card
        style={{ width: "50%", margin: "20px auto" }}
        className="newClinician"
      >
        <Form
          form={form}
          colon={false}
          size={"medium"}
          name="new_clinician"
          onFinish={handleSubmit}
          onValuesChange={handleFieldChange}
          disabled={props?.editData}
          labelAlign="left"
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 12,
          }}
        >
          <Form.Item
            name="first_name"
            label="First Name"
            rules={[
              {
                required: true,
                message: ``,
              },
              Validators.validateFirstName,
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="last_name"
            label="Last Name"
            rules={[Validators.validateLastName]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="email"
            label="Email"
            rules={[
              {
                required: true,
                message: `This field cannot be empty`,
              },
              Validators.checkEmail,
            ]}
          >
            <Input disabled={false} />
          </Form.Item>
          <Form.Item
            name="mobile_number"
            label="Mobile Number"
            rules={[
              { required: true, message: "" },
              {
                required: true,
                validator: (_, value) =>
                  value
                    ? isValidPhoneNumber(value)
                      ? Promise.resolve()
                      : Promise.reject("Please enter a valid mobile number")
                    : Promise.reject(`Please enter mobile number`),
              },
            ]}
          >
            <div className="mobile-input">
              <PhoneInput
                className="signup-mobile-input"
                international={true}
                defaultCountry="IN"
                value={form.getFieldValue("mobile_number")}
                onChange={(value) => {
                  form.setFieldsValue({ mobile_number: value });
                }}
              />
            </div>
          </Form.Item>
          <Form.Item
            name="qualification"
            label="Qualification"
            rules={[
              {
                required: true,
                message: "please enter qualification",
              },
            ]}
          >
            <Input disabled={false} />
          </Form.Item>
          <Form.Item
            name="specialization"
            label="Specialization"
            rules={[
              {
                required: true,
                message: "please select specialization",
              },
            ]}
            shouldUpdate={(prevValues, currentValues) =>
              prevValues.specialization !== currentValues.specialization
            }
          >
            <Input disabled={false} />
          </Form.Item>
          <Form.Item
            name="salutation"
            label="Salutation"
            rules={[
              {
                required: true,
                message: "please enter salutation",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="display_name"
            label="Display Name"
            rules={[
              {
                required: true,
                message: "Please enter your display name",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="designation"
            label="Designation"
            rules={[
              {
                required: true,
                message: "please enter designation",
              },
            ]}
            shouldUpdate={(prevValues, currentValues) =>
              prevValues.designation !== currentValues.designation
            }
          >
            <Input disabled={false} />
          </Form.Item>
          <Form.Item
            name="display_designation"
            label="Display Designation"
            rules={[
              {
                required: true,
                message: "Please input your display desgination",
              },
            ]}
            shouldUpdate={(prevValues, currentValues) =>
              prevValues.display_designation !==
              currentValues.display_designation
            }
          >
            <Input disabled={false} />
          </Form.Item>
          <Form.Item
            name="registration_number"
            label="Registration Number"
            rules={[
              {
                required: true,
                message: "Please enter your registration number",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="speciality"
            label="Speciality"
            rules={[
              {
                required: true,
                message: "Please select speciality",
              },
            ]}
            shouldUpdate={(prevValues, currentValues) =>
              prevValues.speciality !== currentValues.speciality
            }
          >
            <Select
              placeholder="select specialization"
              onFocus={() => fetchOptions("speciality")}
              options={specialityOptions}
              disabled={false}
            />
          </Form.Item>
          <Form.Item
            name="language"
            label="Language "
            rules={[
              {
                required: true,
                message: "please select language",
              },
            ]}
          >
            <Select
              showArrow
              mode="multiple"
              placeholder="select one language"
              // onChange={handleChange}
              onFocus={() => fetchOptions("language")}
              options={languageOptions}
            />
          </Form.Item>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              marginRight: "100px",
              // gap: "10px",
            }}
          >
            <Form.Item>
              <Button
                disabled={false}
                type="primary"
                loading={buttonLoader}
                htmlType="submit"
                style={{ background: "#12005F", color: "white" }}
              >
                {props?.editData ? "Update" : "Submit"}
              </Button>
            </Form.Item>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default NewClinician;
